/*
 * @Auther: 罗耀祖
 * @Date: 2021-12-24 11:05:26
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-03 11:05:12
 * @name: 事件总线配置
 * @Description: 事件总线配置
 * @FilePath: \project\src\config\eventBus.config.js
 * @Author: desktop
 */
export const eventBusConfig = [
  {
    text: '我的售后列表发生变更',
    value: 'afterSaleList_change',
  },
  {
    text: '待审批列表发生变更',
    value: 'afterSaleWaitApproveList_change',
  },
  {
    text: '待确认列表发生变更',
    value: 'afterSaleWaitConfirmList_change',
  },
  {
    text: '待处理列表发生变更',
    value: 'afterSaleWaitDealList_change',
  },
]
export const getEventBus = (text) => {
  return eventBusConfig.find(x => x.text === text).value;
}